module.exports = __webpack_public_path__ + "static/img/1-01.60ebc33.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-01.png
// module id = 202
// module chunks = 0